import { Component } from '@angular/core';
import { first } from 'rxjs/operators';

import { User } from '@app/_models';
import { UserService, AuthenticationService } from '@app/_services';

@Component({ templateUrl: 'formiotest.component.html' })
export class FormioTestComponent {
    loading = false;
    users: User[];

    constructor(private userService: UserService) { }

    ngOnInit() {
    }

    onSubmit(submission: any) {
        console.log(submission); // This will print out the full submission from Form.io API.
    }
}